import React from 'react';

import RangeSelector, { SliderProps } from '../RangeSelector';

interface RangeSelectorProps {
    label: string;
    rangeSelectorProps: SliderProps;
}

const RangeSelectorFormGroup: React.FC<RangeSelectorProps> = ({ label, rangeSelectorProps }) => (
    <>
        <div style={{ gridColumn: 1 }}>
            <strong>{label}:</strong>
        </div>
        <div style={{ gridColumn: '2/5' }}>
            <RangeSelector {...rangeSelectorProps} />
        </div>
    </>
);

export default RangeSelectorFormGroup;
